"use strict";

var ubian = ubian || {};
/**
 * card buy related methods
 * @type Object
 */
ubian.cardBuyType = {
  /**
   * @var int Type of selected card type
   */
  selectedCardTypeID: null,
  photoRequired: false
};

ubian.cardBuyType.getCardType = function() {
  if (window.location.href.indexOf("emulated") >= 0) {
    return "emulated";
  }
  return "normal";
};

ubian.cardBuyType.updatePhotoField = function(isRequired) {
  ubian.cardBuyType.photoRequired = isRequired;
  var isOptional = cardBuyType_timeTicketSaleEnabled;
  var $photoForm = $(".js-photo-form");
  if (!isOptional && !isRequired) {
    $photoForm.hide();
    return;
  }
  $photoForm.find(".info-label").hide();
  if (isRequired) {
    $photoForm.find(".info-label--required").show();
  } else {
    $photoForm.find(".info-label--optional").show();
  }
  $photoForm.show();
};

/**
 * update upload fields list and status (on card type change or after upload is finished)
 */
ubian.cardBuyType.getInputs = function(id, forceScroll) {
  $(".js-required-inputs").html(ubian.utils.loader());
  var url = $.post(ubian.routes["card_buy_fields"], { type: id }, function(
    result
  ) {
    if (!result.inputs) {
      $(".js-uploadable-fields").hide();
    } else {
      $(".js-uploadable-fields").show();
    }
    ubian.cardBuyType.updatePhotoField(result.photoRequired);
    $(".js-required-inputs").html(result.inputs);
    if (typeof forceScroll !== "undefined" && forceScroll) {
      var top = $(".js-card-details").offset().top - 170;
      $([document.documentElement, document.body]).animate({ scrollTop: top });
    }
    $(".js-required-inputs input[type=file]").change(function() {
      ubian.cardBuyType.uploadDocument(this);
    });
    $(".js-required-inputs .js-delete-file").click(function() {
      $(".js-required-inputs").html(ubian.utils.loader());
      $.post(
        ubian.routes["card_buy_remove_upload"],
        { fileType: $(this).data("id") },
        function() {
          ubian.cardBuyType.getInputs(ubian.cardBuyType.selectedCardTypeID);
        }
      );
    });
    ubian.cardBuyType.updateContinueButton();
  });
};

ubian.cardBuyType.updateContinueButton = function() {
  $(".btn-continue").attr("disabled", true);
  if ($(".js-document-row").length !== $(".js-delete-file").length) {
    return;
  }
  if (
    ubian.cardBuyType.photoRequired &&
    $(".js-photo-preview-wrapper").hasClass("empty")
  ) {
    return;
  }
  $(".btn-continue").removeAttr("disabled");
};

ubian.cardBuyType.uploadDocument = function(input) {
  if (!$(input).val()) {
    return;
  }
  $(".js-required-inputs").html(ubian.utils.loader());
  var $formData = new FormData();
  $formData.append("file", $(input)[0].files[0]);
  $formData.append("fileType", $(input).data("fileid"));
  $.ajax(ubian.routes["card_buy_upload_image"], {
    type: "POST",
    data: $formData,
    cache: false,
    contentType: false,
    processData: false,
    success: function(result) {
      if (result.error) {
        ubian.utils.alert(ubian.translate(result.error));
      }
      ubian.cardBuyType.getInputs(ubian.cardBuyType.selectedCardTypeID);
    }
  });
};

ubian.cardBuyType.changeType = function(item) {
  $(".js-card-type").removeClass("selected");
  $(".js-card-type .btn").text(ubian.translate("Button.Select"));
  var id = $(item).data("id");
  $(item).addClass("selected");
  $(item)
    .find(".btn")
    .text(ubian.translate("Button.Selected"));
  $(".js-card-details").show();
  $(".js-card-price").text(
    ubian.cardBuyType.getCardType() == "normal"
      ? $(item).data("price")
      : $(item).data("price-emulated")
  );
  ubian.cardBuyType.selectedCardTypeID = id;
  return id;
};

ubian.cardBuyType.submit = function() {
  var data = { cardTypeId: ubian.cardBuyType.selectedCardTypeID };
  $.post(
    ubian.routes["card_buy_type_validate"].replace(
      "--type--",
      ubian.cardBuyType.getCardType()
    ),
    data,
    function(result) {
      if (result && result.valid) {
        window.location = ubian.routes["card_buy_products"].replace(
          "--type--",
          ubian.cardBuyType.getCardType()
        );
      } else {
        ubian.utils.alert(
          ubian.translate("Card.Buy.Error.MissingRequiredDocuments")
        );
      }
    }
  );
};

ubian.cardBuyType.init = function() {
  if (!$("body").hasClass("buy-card--type-screen")) {
    return;
  }
  $(".js-card-type").on("click", function() {
    var type = ubian.cardBuyType.changeType(this);
    ubian.cardBuyType.getInputs(type, true);
  });
  $(".btn-continue").on("click", function(event) {
    if (!$(this).is(":disabled")) {
      ubian.cardBuyType.submit();
    }
  });
  if (cardBuyType_forceCardType) {
    $(".js-card-type[data-id=" + cardBuyType_forceCardType + "]").click();
  } else if ($(".js-card-type").length === 1) {
    $(".js-card-type").click();
  }
};

$(ubian.cardBuyType.init);
